import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { ListItem, Inline, Button } from 'chaoskit/src/components'

import Icon from '~components/Icon'

const SocialWidget = ({ contrast, currentPageUrl, title, ...rest }) => {
  const theme = useTheme()

  const networks = [
    {
      service: 'twitter',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        title
      )}&url=${currentPageUrl}`,
      title: 'Share on Twitter',
    },
    {
      service: 'facebook',
      url: `https://www.facebook.com/sharer.php?u=${currentPageUrl}`,
      title: 'Share on Facebook',
    },
    {
      service: 'linkedin',
      url: `https://www.linkedin.com/shareArticle?title=${encodeURIComponent(
        title
      )}&url=${currentPageUrl}`,
      title: 'Share on LinkedIn',
    },
    {
      service: 'hacker-news',
      url: `http://news.ycombinator.com/submitlink?u=${currentPageUrl}&t=${encodeURIComponent(
        title
      )}`,
      title: 'Share on Hacker News',
    },
    {
      service: 'rss',
      url: '/rss.xml',
      title: 'View RSS Feed',
    },
  ]

  return (
    <Inline {...rest}>
      {networks.map((network) => (
        <ListItem key={network.service}>
          <Button
            url={network.url}
            type="reset"
            css={[
              {
                transition: `transform ${theme.timing.base} ${theme.transition.bounce}`,
                transformOrigin: 'center center',
                display: 'inline-block',

                '&:hover, &:focus': {
                  transform: 'scale(1.15)',
                },
              },

              contrast && {
                color: theme.contrast.base,

                '&:hover, &:focus': {
                  color: theme.contrast.base,
                },
              },
            ]}
          >
            <Icon size="medium" icon={network.service} />
          </Button>
        </ListItem>
      ))}
    </Inline>
  )
}

SocialWidget.propTypes = {
  contrast: PropTypes.bool,
  currentPageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default SocialWidget
